import React, { useMemo } from 'react';
import { LorawanActionTypes } from '@utils/deviceActions';
import {
  DeviceActionProps,
  DeviceActionStepsProps,
} from '@components/Actions/ActionsModal/types';
import { DeviceLoraWanProps } from '@pages/LoraWan/types';
import { useTranslation } from 'react-i18next';
import { Form, FormInstance, Input } from 'antd';
import rolesConstants from '@utils/rolesConstants';

interface ChangeDescriptionPayloadProps {
  action: LorawanActionTypes.CHANGE_DESCRIPTION;
  devices: {
    devEui: string;
    description: string;
  }[];
}

interface ChangeDescriptionProps {
  devices: DeviceLoraWanProps[];
  isUpload?: boolean;
  form: FormInstance<any>;
}

const useChangeDescription = ({
  devices,
  isUpload,
  form,
}: ChangeDescriptionProps): DeviceActionProps => {
  const { t } = useTranslation(['lorawan', 'device-actions']);
  const description = Form.useWatch('description', form);

  const steps: DeviceActionStepsProps[] = useMemo(
    () => [
      {
        title: t('newDescription'),
        name: 'description',
        content: <Input allowClear />,
      },
    ],
    [t],
  );

  const payloadToSend = useMemo(
    (): ChangeDescriptionPayloadProps => ({
      action: LorawanActionTypes.CHANGE_DESCRIPTION,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            devEui: device.devEui,
            description,
          })),
    }),
    [description, devices, isUpload],
  );

  return {
    steps,
    payloadToSend,
    title: t(
      `device-actions:labels.lorawan.${rolesConstants.LORAWAN_CHANGE_DESCRIPTION}`,
    ),
  };
};

export default useChangeDescription;
